import { site, stats } from "@/mocks/gossip";

const contactPoints = [
  { icon: "ri-mail-send-line", label: "投稿 / 线索", value: "tougao@meirigualliao.example", note: "请附上可核验来源与时间点" },
  { icon: "ri-chat-3-line", label: "意见反馈", value: "hello@meirigualliao.example", note: "建议与批评我们都认真看" },
  { icon: "ri-team-line", label: "特约作者", value: "作者计划长期招募", note: "欢迎签约与专栏共创" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-medium uppercase tracking-widest text-accent-600">About Us</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              关于每日瓜料
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们是一群把“好好吃瓜”当正事的内容人。市面上的瓜散落各处、真假难辨，
              于是做了每日瓜料——把一周热门瓜与近期新瓜集中到一页，按热度归档、逐条标注来源，
              让每个吃瓜群众都能省下到处翻找的时间。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们相信，娱乐热点值得被更认真对待：先核实、再呈现，不煽动、不造谣，
              把“热闹”讲清楚，也把“门道”讲明白。
            </p>
            <dl className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl border border-background-200 bg-background-50 px-4 py-4 text-center"
                >
                  <dt className="font-heading text-2xl font-bold text-primary-600">{s.value}</dt>
                  <dd className="mt-1 text-xs text-foreground-600">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-heart-3-fill text-accent-500" aria-hidden="true"></i>
                我们的内容原则
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {[
                  "先核实再呈现，事实与观点清晰区分",
                  "标注来源与时间线，不做无出处传播",
                  "尚在发酵事件明确标注“进行中”",
                  "尊重当事人，绝不编造或恶意揣测",
                ].map((t, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <span className="mt-1 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-primary-500 text-[10px] text-background-50">
                      <i className="ri-check-line" aria-hidden="true"></i>
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col gap-3">
              {contactPoints.map((c) => (
                <a
                  key={c.label}
                  href={`mailto:${c.value.startsWith("tougao") || c.value.startsWith("hello") ? c.value : "hello@meirigualliao.example"}`}
                  className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:bg-background-100/60"
                >
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-secondary-500/15 text-secondary-700">
                    <i className={`${c.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-semibold text-foreground-900">{c.label}</span>
                    <span className="mt-0.5 block truncate text-sm text-primary-700">{c.value}</span>
                    <span className="mt-0.5 block text-xs text-foreground-500">{c.note}</span>
                  </span>
                  <i className="ri-arrow-right-line mt-2 text-foreground-400 transition-colors group-hover:text-primary-600" aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}